import React from 'react';
import { GovMessage } from '@gov-design-system-ce/react';
import type { RezaPortalInfo } from '@gov-nx/api';
import { MarkdownRender } from '@gov-nx/component/web';
import { Button, Icon } from '@gov-nx/ui/web';

interface Props {
	portalInfo: RezaPortalInfo;
}

export const PortalInfo = ({ portalInfo }: Props) => (
	<GovMessage
		color="primary"
		type="subtle"
		icon={
			<Icon
				type="components"
				name="lightbulb-fill"
			/>
		}>
		<div className="flex-col flex justify-between items-start gap-4 [ sm:flex-row ]">
			{portalInfo?.portalDescription ? (
				<MarkdownRender>{portalInfo.portalDescription}</MarkdownRender>
			) : null}

			<PortalInfoButton portalInfo={portalInfo} />
		</div>
	</GovMessage>
);

export const PortalInfoButton = ({ portalInfo }: Props) => (
	<Button
		onClick={() => window.open(portalInfo.portalURL, '_blank')}
		isExpandedMobile
		color="primary"
		type="outlined"
		iconEnd={
			<Icon
				name="box-arrow-up-right"
				type="components"
			/>
		}
		size="s">
		{portalInfo.portalName}
	</Button>
);
